<template>
  <b-modal
    :id="modalId"
    centered
    hide-footer
    title="Filters"
    size="lg">
    <div class="row">
      <div v-if="showStatusFilter" class="col-md-6 mb-3">
        <label class="form-label">Status</label>
        <v-select
          v-model="localFilters.status"
          :options="statusOptions"
          :reduce="option => option.value"
          label="label"
          placeholder="Choose Status">
        </v-select>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Approval</label>
        <v-select
          v-model="localFilters.approval_step"
          :options="approvalStepOptions"
          :reduce="option => option.value"
          label="label"
          placeholder="Choose Approval">
        </v-select>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Course Type</label>
        <v-select
          v-model="localFilters.course_type"
          :options="courseTypeOptions"
          :reduce="option => option.value"
          label="label"
          placeholder="Choose Course Type">
        </v-select>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-3 mt-4">
      <button
        type="button"
        class="btn btn-outline-danger"
        @click="resetFilters">
        Reset filters
      </button>
      <button
        type="button"
        class="btn btn-danger"
        @click="applyFilters">
        Apply filters
      </button>
    </div>
  </b-modal>
</template>

<script>
const emptyFilters = () => ({
  status: null,
  approval_step: null,
  course_type: null
});

export default {
  name: 'ModalCourseFilter',
  props: {
    modalId: {
      type: String,
      default: 'modal-course-filter'
    },
    value: {
      type: Object,
      default: () => ({})
    },
    statusOptions: {
      type: Array,
      default: () => []
    },
    showStatusFilter: {
      type: Boolean,
      default: false
    },
    approvalStepOptions: {
      type: Array,
      default: () => []
    },
    courseTypeOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localFilters: emptyFilters()
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        this.localFilters = {
          ...emptyFilters(),
          status: val?.status || null,
          approval_step: val?.approval_step || null,
          course_type: val?.course_type || null
        };
      }
    }
  },
  methods: {
    resetFilters() {
      this.localFilters = emptyFilters();
      this.$emit('reset-filters');
    },
    applyFilters() {
      this.$emit('apply-filters', {
        ...this.localFilters,
        status: this.showStatusFilter ? this.localFilters.status : null
      });
      this.$bvModal.hide(this.modalId);
    }
  }
};
</script>

<style scoped>
.gap-3 {
  gap: 1rem;
}
</style>
